import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, withRouter, useHistory } from 'react-router-dom';

import Header from '../../../components/Header';
import Subheader from '../../../components/Fastag/Subheader/';
import Listing from '../../../components/Fastag/Listing';
import { getQueryObj } from '../../../utils/utils';
import { Vehicle } from '../../../components/Fastag/Listing';

import { ListingWrapper } from '../../../components/_globalStyled';
import { sendEvent2 } from '../../../utils/tracking';
import { getUserCode } from '../../../utils/apiConfig';

const VehicleList: FunctionComponent = (props: any) => {
  useEffect(() => {
    sendEvent2(
      'screen_view',
      {
        event_action: 'view',
        event_category: '',
        screen_name: 'ft_homescreen',
        miscellaneous: JSON.stringify({
          op_code: getUserCode(),
        }),
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);
  const location = useLocation();
  const queryObj: any = getQueryObj(location.search);

  const vehicles: Array<Vehicle> = useSelector((state: any) => state.fasTag.data.list);
  const isLoaded: boolean = useSelector((state: any) => state.fasTag.loaded);
  const search = queryObj.search;

  const history = useHistory();
  return (
    <div>
      <Header title="Fastag" link="/portal/fastag" history={history}>
        {isLoaded ? !(vehicles && vehicles.length) && !search ? null : <Subheader searchText={search} /> : null}
      </Header>
      <ListingWrapper>
        <Listing search={search} />
      </ListingWrapper>
    </div>
  );
};

export default withRouter(VehicleList);
